"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("styled-is"));
var _vaul = require("vaul");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _DrawerOptionsListItem = _interopRequireDefault(require("./DrawerOptionsListItem"));
var _variables = require("../../styles/variables");
var _HBDrawerComponents = require("./HBDrawerComponents");
var _spacing = _interopRequireDefault(require("../../styles/spacing"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _useDetectScroll2 = require("../common/useDetectScroll");
var _HBCloseButton = _interopRequireDefault(require("../HBCloseButton/HBCloseButton"));
var _ActionButtons = _interopRequireDefault(require("../common/ActionButtons"));
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBDrawer = function HBDrawer(_ref) {
  var children = _ref.children,
    className = _ref.className,
    onClose = _ref.onClose,
    open = _ref.open,
    options = _ref.options,
    parent = _ref.parent,
    subTitle = _ref.subTitle,
    title = _ref.title,
    primaryAction = _ref.primaryAction,
    secondaryAction = _ref.secondaryAction,
    _ref$removeTopPadding = _ref.removeTopPadding,
    removeTopPadding = _ref$removeTopPadding === void 0 ? false : _ref$removeTopPadding;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    contentElement = _useState2[0],
    setContentElement = _useState2[1];
  var _useDetectScroll = (0, _useDetectScroll2.useDetectScroll)({
      elementRef: contentElement,
      detectCondition: open
    }),
    isScrolled = _useDetectScroll.isScrolled;
  var hasOptions = !!(options !== null && options !== void 0 && options.length);
  var shouldAddTopPadding = !removeTopPadding && !hasOptions;
  return /*#__PURE__*/_react["default"].createElement(_vaul.Drawer.Root, {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_vaul.Drawer.Portal, {
    container: parent
  }, /*#__PURE__*/_react["default"].createElement(StyledDrawerOverlay, {
    isPortaledToParent: !!parent
  }), /*#__PURE__*/_react["default"].createElement(StyledDrawerContent, {
    className: className,
    onClose: onClose,
    setContentRef: setContentElement
  }, /*#__PURE__*/_react["default"].createElement(HeaderContainer, {
    isScrolling: isScrolled
  }, /*#__PURE__*/_react["default"].createElement(Handle, null), title && /*#__PURE__*/_react["default"].createElement(Header, null, /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "display24",
    color: "textPrimary"
  }, title), subTitle && /*#__PURE__*/_react["default"].createElement(_HBText["default"], {
    type: "body16",
    color: "textSecondary"
  }, subTitle)), /*#__PURE__*/_react["default"].createElement(_HBCloseButton["default"], {
    distance: 6,
    size: "sm",
    onClick: onClose,
    testIdName: "drawer-close",
    theme: "dark"
  })), /*#__PURE__*/_react["default"].createElement(Body, {
    addTopPadding: shouldAddTopPadding
  }, options === null || options === void 0 ? void 0 : options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_DrawerOptionsListItem["default"], (0, _extends2["default"])({
      closeDrawer: onClose,
      key: option.testIdName
    }, option));
  }), children), /*#__PURE__*/_react["default"].createElement(_ActionButtons["default"], {
    sticky: "bottom",
    align: "center",
    primaryAction: primaryAction,
    secondaryAction: secondaryAction,
    containerRef: contentElement
  }))));
};
var _default = exports["default"] = HBDrawer; // -------------------------------- Styles -------------------------------- //
var StyledDrawerOverlay = (0, _styledComponents["default"])(_HBDrawerComponents.DrawerOverlay).withConfig({
  displayName: "HBDrawer__StyledDrawerOverlay",
  componentId: "sc-1f3ls8w-0"
})(["position:fixed;inset:0;z-index:", ";background-color:", ";", ""], _variables.Z_INDEX.TOP_MOST, _colors["default"].black_07, (0, _styledIs["default"])('isPortaledToParent')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        position: absolute;\n        z-index: 2;\n    "]))));
var StyledDrawerContent = (0, _styledComponents["default"])(_HBDrawerComponents.DrawerContent).withConfig({
  displayName: "HBDrawer__StyledDrawerContent",
  componentId: "sc-1f3ls8w-1"
})(["position:fixed;z-index:", ";bottom:0;inset-inline:0;max-height:90%;overflow-y:auto;background:", ";border-top-left-radius:", ";border-top-right-radius:", ";&::after{display:none;}"], _variables.Z_INDEX.POPOVER, _colors["default"].white, _spacing["default"][8], _spacing["default"][8]);
var inlinePadding = '16px';
var Handle = _styledComponents["default"].div.withConfig({
  displayName: "HBDrawer__Handle",
  componentId: "sc-1f3ls8w-2"
})(["height:4px;border-radius:2px;width:40px;background:", ";position:relative;top:2px;align-self:center;"], _colors["default"].neutral400);
var HeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBDrawer__HeaderContainer",
  componentId: "sc-1f3ls8w-3"
})(["display:flex;flex-direction:column;gap:20px;min-height:48px;padding:6px ", ";z-index:1;position:sticky;top:0;background:", ";", ""], inlinePadding, _colors["default"].white, (0, _styledIs["default"])('isScrolling')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);\n    "]))));
var Header = _styledComponents["default"].div.withConfig({
  displayName: "HBDrawer__Header",
  componentId: "sc-1f3ls8w-4"
})(["align-self:flex-start;display:flex;flex-direction:column;align-items:flex-start;gap:4px;"]);
var Body = _styledComponents["default"].div.withConfig({
  displayName: "HBDrawer__Body",
  componentId: "sc-1f3ls8w-5"
})(["padding:0 ", " 20px;overflow-y:auto;", ""], inlinePadding, (0, _styledIs["default"])('addTopPadding')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        padding-top: 16px;\n    "]))));
//# sourceMappingURL=HBDrawer.js.map